<template>
  <div class="mt-4">
    <h3>Add a lesson</h3>
    <v-text-field v-model="name" label="Name" :error-messages="nameErrors"></v-text-field>
    <v-textarea
      v-model="description"
      label="Description"
      :error-messages="descriptionErrors"
    ></v-textarea>
    <v-text-field v-model="pdfLink" label="MaterialPDFLink"></v-text-field>
    <!-- <v-text-field
      v-model="capacity"
      label="Capacity"
      type="number"
      :error-messages="capacityErrors"
    ></v-text-field> -->

    <v-layout row wrap align-center>
      Start (GMT):
      <v-flex xs4 ml-2>
        <v-menu v-model="startAtDateEditting" :close-on-content-click="false" min-width="290px">
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="startAtDate"
              label="Date"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="startAtDate"
            :show-current="false"
            @input="startAtDateEditting = false"
          >
          </v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs4 ml-2>
        <v-menu
          ref="startAtTime"
          v-model="startAtTimeEditting"
          :close-on-content-click="false"
          min-width="290px"
        >
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="startAtTime"
              label="Time"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="startAtTimeEditting"
            v-model="startAtTime"
            full-width
            @click:minute="$refs.startAtTime.save(startAtTime)"
          ></v-time-picker>
        </v-menu>
      </v-flex>
    </v-layout>
    <div class="font-red">{{ startAtErrors ? startAtErrors[0] : '' }}</div>

    <v-layout row wrap align-center>
      End (GMT):
      <v-flex xs4 ml-2>
        <v-menu v-model="endAtDateEditting" :close-on-content-click="false" min-width="290px">
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="endAtDate"
              label="Date"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="endAtDate"
            :show-current="false"
            @input="endAtDateEditting = false"
          >
          </v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs4 ml-2>
        <v-menu
          ref="endAtTime"
          v-model="endAtTimeEditting"
          :close-on-content-click="false"
          min-width="290px"
        >
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="endAtTime"
              label="Time"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="endAtTimeEditting"
            v-model="endAtTime"
            full-width
            @click:minute="$refs.endAtTime.save(endAtTime)"
          ></v-time-picker>
        </v-menu>
      </v-flex>
    </v-layout>
    <div class="font-red">{{ endAtErrors ? endAtErrors[0] : '' }}</div>

    <v-layout justify-end>
      <v-btn color="primary" @click="createLesson()">submit</v-btn>
      <v-progress-circular
        v-show="loading"
        :value="20"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-layout>
  </div>
</template>

<script>
import { RequestLessons } from '../../../requests/study-program/lessons';

export default {
  props: { studyGroupId: { type: Number, default: () => 0 } },

  data() {
    return {
      name: '',
      nameErrors: [],
      description: '',
      descriptionErrors: [],
      pdfLink: null,
      capacity: 0,
      capacityErrors: [],
      startAtDate: '',
      startAtDateEditting: false,
      startAtTime: '',
      startAtTimeEditting: false,
      startAtErrors: [],
      endAtDate: '',
      endAtDateEditting: false,
      endAtTime: '',
      endAtTimeEditting: false,
      endAtErrors: [],
      loading: false,
    };
  },

  mounted() {
    const d = new Date();
    const month = d.getUTCMonth() + 1;
    const date = d.getUTCDate();
    let dateString = `${d.getUTCFullYear()}-${month >= 10 ? month : '0' + month}-${
      date >= 10 ? date : '0' + date
    }`;
    const hours = d.getUTCHours();
    const minutes = d.getUTCMinutes();
    let timeString = `${hours >= 10 ? hours : '0' + hours}:${
      minutes >= 10 ? minutes : '0' + minutes
    }`;
    this.startAtDate = dateString;
    this.startAtTime = timeString;
    this.endAtDate = dateString;
    this.endAtTime = timeString;
  },

  methods: {
    async createLesson() {
      this.nameErrors = [];
      this.descriptionErrors = [];
      this.startAtErrors = [];
      this.endAtErrors = [];

      let start_at = new Date(`${this.startAtDate} ${this.startAtTime}`).toLocaleString();
      let end_at = new Date(`${this.endAtDate} ${this.endAtTime}`).toLocaleString();

      this.loading = true;
      try {
        const lesson = await RequestLessons.create(
          this.studyGroupId,
          this.name,
          this.description,
          start_at,
          end_at,
          this.pdfLink,
          this.capacity
        );
        this.$emit('create-new', lesson);
        this.clearField();
      } catch (e) {
        if (e.response && e.response.status == 422) {
          this.nameErrors = e.response.data.name;
          this.descriptionErrors = e.response.data.description;
          this.capacityErrors = e.response.data.capacity;
          this.startAtErrors = e.response.data.start_at;
          this.endAtErrors = e.response.data.end_at;
        } else {
          this.nameErrors.push('Network connection error!');
        }
      } finally {
        this.loading = false;
      }
    },

    clearField() {
      this.name = '';
      this.description = '';
      this.pdfLink = '';
      this.capacity = 0;
    },
  },
};
</script>
